import styled from 'styled-components';

const StyledTimeframeSelector = styled.div`
  background-color: ${props => props.theme.colors.light_dark};
  padding: ${props => props.theme.spacing.small}
    ${props => props.theme.spacing.large};
  min-height: 42px;
`;

export { StyledTimeframeSelector };
